module.exports = __webpack_public_path__ + "toBride1-jp-r-n.24942f07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-jp-r-n.jpg
// module id = YYbT
// module chunks = 0